module.exports = __webpack_public_path__ + "static/media/Productos.e3b1902e.png";